<template>
  <el-card shadow="never" class="home-dashboard__card home-freight">
    <div slot="header" class="home-freight__header">
      <span class="home-dashboard__card-title" style="cursor: pointer" @click="open = !open">
        Calculadora de frete
      </span>
      <span class="home-freight__controls">
        <span class="home-freight__toggle" @click="open = !open">
          {{ open ? $t("ocultar") : $t("exibir") }}
          <i :class="open ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </span>
      </span>
    </div>

    <!-- Atalho sem duplicação: é o MESMO CalculateForm da tela
         /servicos/calculadora — calcular aqui cai no resultado do fluxo
         existente (calculadora.frete.resultado) -->
    <CalculateForm v-if="open" :userType="userType" :result-in-modal="true"
      @result="$refs.resultDialog.open()" />
    <CalculateResultDialog ref="resultDialog" />
  </el-card>
</template>

<script>
import CalculateForm from "@/maisenvios/page/services/calculate/CalculateForm.vue";
import CalculateResultDialog from "@/maisenvios/page/services/calculate/CalculateResultDialog.vue";

export default {
  name: "HomeFreightCalc",
  components: { CalculateForm, CalculateResultDialog },
  props: {
    userType: { type: String, default: "2" },
  },
  data() {
    return {
      open: true,
    };
  },
};
</script>

<style>
.home-freight__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.home-freight__controls {
  display: flex;
  align-items: center;
}

.home-freight__toggle {
  font-size: 12px;
  color: var(--me-text-secondary);
  cursor: pointer;
  margin-left: 14px;
}
</style>
